export const assetOrderModalCopy = {
    buy: {
        titlePre: 'Approve Purchase',
        titleLoading: 'Your Purchase is processing',
        titlePost: 'Your Purchase is Complete',
        actionText: "You'll be asked to approve this purchase from your wallet.",
        viewAssetCta: 'View your asset',
    },
    list: {
        titlePre: 'Approve Listing',
        titlePost: 'Your Listing is Complete',
        actionText: "You'll be asked to approve this listing from your wallet.",
        viewAssetCta: 'View your asset',
    },
    offer: {
        titlePre: 'Approve Offer',
        titlePost: 'Your Offer is Complete',
        actionText: "You'll be asked to approve this offer from your wallet.",
        viewAssetCta: 'View the asset',
    },
};

export const assetOrderSheetCopy = {
    offer: {
        title: 'Make offer',
        ctaCopy: 'Make offer',
        period: 'Set offer period',
    },
    list: {
        title: 'List on sale',
        ctaCopy: 'List item',
        period: 'Set listing period',
    },
};
